/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgModule } from '@angular/core';
import { DashGisNg2ResizableHandleDirective } from './dash-gis-ng2-resizable-handle.directive';
import { DashGisNg2ResizableDirective } from './dash-gis-ng2-resizable.directive';
import { ResizableListenerService } from './resizableListener.service';

@NgModule({
    declarations: [DashGisNg2ResizableDirective, DashGisNg2ResizableHandleDirective],
    exports: [DashGisNg2ResizableDirective, DashGisNg2ResizableHandleDirective],
    providers: [ResizableListenerService],
})
export class DashGisNg2ResizableModule {}
